import {
    ORDERLOADING,
    ORDERSUCCESS,
    ORDERERROR,
    ORDERFAILED,
    ORDERRESET
} from "../actionTypes";
const init_state = {
    status: null,
    failedMessage: null,
    error: false,
    errorMessage: null,
    loading: false
}
export const orderReducer = (state = init_state, {
    type,
    payload
}) => {
    switch (type) {
        case ORDERRESET: 
          return init_state

        case ORDERSUCCESS:
            return {
                ...state,
                status: "completed",
                failedMessage: null,
                error: false,
                errorMessage: null

            }
            case ORDERERROR:
                return {
                    ...state,
                    status: null,
                    failedMessage: null,
                        error: true,
                        errorMessage: payload
                }
                case ORDERLOADING:
                    return {
                        ...state,
                            loading: true,
                            status: null,
                            failedMessage: null,
                            error: false,
                            errorMessage: null,
                    }
                    case ORDERFAILED:
                        return {
                            ...state,
                            status: "failed",
                            failedMessage: payload,
                                loading: false,
                                error: false,
                                errorMessage: ""
                        }
                        default:
                            return state
    }
}